export default __webpack_public_path__ + "static/1_6-fc3bd1ec69d7a50e685add0d7e6bdcd8.png";